import { render, staticRenderFns } from "./OpenShop.vue?vue&type=template&id=fd30a7a2&scoped=true"
import script from "./OpenShop.vue?vue&type=script&lang=js"
export * from "./OpenShop.vue?vue&type=script&lang=js"
import style0 from "./OpenShop.vue?vue&type=style&index=0&id=fd30a7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd30a7a2",
  null
  
)

export default component.exports